import { IBundle } from "@/api/AppApi/services/home/interfaces/IProductBundle";
import { useGetProductDetailsQuery } from "@/api/AppApi/services/product";
import ProductsBundle from "@/app/components/common-builder/products-bundle";
import GeneralApiLoader from "@/app/components/lib/loaders/GeneralApiLoader";
import React from "react";

const BundleAssociatedProduct: React.FC<{ slug: number | string }> = ({
  slug,
}) => {
  const {
    data: productDetailsData,
    isLoading,
    isError,
  } = useGetProductDetailsQuery({
    params: { id: slug },
  });

  const product: IBundle = productDetailsData?.result!;
  if (!slug || !product || isError) return null;

  return isLoading ? (
    <GeneralApiLoader />
  ) : (
    <div>
      <ProductsBundle
        data={{
          title: product?.name,
          product: product,
        }}
      />
    </div>
  );
};

export default BundleAssociatedProduct;
